// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__Ps_1k","tabsList":"Tabs_tabsList__jdFIw"};